import { ESimplifiedBuyingImpl } from "../data/ESimplifiedBuyingImpl";
import { IESimplifiedBuyingRepository } from "../domain/repositories/IESimplifiedBuyingRepository";
import { ESimplifiedBuyingUseCase } from "../domain/useCases/ESimplifiedBuyingUseCase";
import { ESimplifiedBuyingViewModel } from "../presentation/viewModel/ESimplifiedBuyingViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class ESimplifiedBuyingInjection extends InjectionModule {
  private static readonly eSimplifiedBuyingRepositoryToken = Symbol(
    "IESimplifiedBuyingRepository",
  );
  private static readonly eSimplifiedBuyingUseCaseToken = Symbol(
    "ESimplifiedBuyingUseCase",
  );
  private static readonly eSimplifiedBuyingViewModelToken = Symbol(
    "ESimplifiedBuyingViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.eSimplifiedBuyingRepositoryToken,
      useClass: ESimplifiedBuyingImpl,
    },
    {
      scope: "otherRepo",
      token: this.eSimplifiedBuyingUseCaseToken,
      useClass: ESimplifiedBuyingUseCase,
    },
    {
      scope: "viewModel",
      token: this.eSimplifiedBuyingViewModelToken,
      useClass: ESimplifiedBuyingViewModel,
    },
  ];

  static getRepo(): IESimplifiedBuyingRepository {
    return this.resolve(this.eSimplifiedBuyingRepositoryToken);
  }

  static getUseCase(): ESimplifiedBuyingUseCase {
    return this.resolve(this.eSimplifiedBuyingUseCaseToken);
  }
}
